import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'
export const api = {
  summaryInfo: ipConfig.api_rms + '/api/v1/mwclg/summary-info', // 统计数据
  orderList: ipConfig.api_rms + '/api/v1/mwclg/order-list', // 订单列表
  orderExtensionInfo: ipConfig.api_rms + '/api/v1/mwclg/order-extension-info', // 订单列表
  orderExport: ipConfig.api_rms + '/api/v1/mwclg/order-export'// 导出订单
}
export function getSummaryInfo (params) {
  return axios({
    url: api.summaryInfo,
    method: 'get',
    params
  })
}
export function getOrderList (params) {
  return axios({
    url: api.orderList,
    method: 'get',
    params
  })
}
export function getOrderExtensionInfo (freightOrderId) {
  const params = { freightOrderId: freightOrderId };
  return axios({
    url: api.orderExtensionInfo,
    method: 'get',
    params
  })
}
export function doneOrderExport (params) {
  return axios({
    url: api.orderExport,
    method: 'get',
    params
  })
}
